<template>
  <div class="general-wrapper">
    <div class="header">
      <h2 v-if="!chain" class="qrw-heading-xl">{{ $t("navbar.corporate_cafes") }}</h2>
      <h2 v-else class="qrw-heading-xl">{{ $t("navbar.chain") }} "{{ chain.name }}"</h2>

      <div class="group">
        <DashboardButton @click="showPopup = true" variant="black">
          {{ $t("add_corporate_cafe.button") }}
        </DashboardButton>
      </div>
    </div>
    <div class="px-50">
      <div
        class="corporate-cafe-container"
        v-for="cafe in corporate_cafes"
        :key="cafe._id"
      >
        <CorporateCafeCard :cafe="cafe" class="p-20" />
      </div>

      <!-- <button
        class="add-cafe"
        @click="showPopup = true"
        v-if="corporate_cafes.length < 5"
      >
        {{ $t("add_corporate_cafe.button") }}
      </button> -->
    </div>

    <AddCafeModal
      :chain_id="chain ? chain._id : null"
      @created="fetchCafes"
      @close="showPopup = false"
      v-if="showPopup"
    />
  </div>
</template>

<style scoped>
.cafe-card-container {
  display: flex;
}
.cafe-card-general {
  display: flex;
}

.info-name {
  line-height: 0.8;
  font-size: 2.8vh;
}

span.address {
  font-size: 1.7vh;
  display: block;
  padding-top: 1.2vh;
  line-height: normal;
}

.card-image {
  margin-right: 1.7vh;
  height: auto;
  width: 37vh;
  position: relative;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blur {
  filter: blur(2px);
}

.p-20 {
  padding: 2.2vh;
}

.settings-btn {
  position: absolute;
  bottom: 0;
  width: 25vh;
}

.card-tags {
  display: flex;
  flex-flow: column;
  bottom: 3.2vh;
  position: absolute;
  right: 0;
  z-index: 0;
  overflow: hidden;
}

.card-mode-tag:first-child {
  margin-top: 0;
}

.card-mode-tag {
  height: auto;
  width: 14vh;
  border-radius: 0.6vh 0 0 0.6vh;
  font-weight: bold;
  padding: 0.5vh 0.5vh;
  margin: 1.1vh 0 0 0.5vh;
  border: none;
  outline: none;
  border: none;
  outline: none;
  font-size: 1.8vh;
  color: #1d1d1d;
}

.card-mode-tag.i {
  background: #1d1d1d;
  color: #ededed;
}
.card-mode-tag.d {
  background: #cbd9e6;
}
.card-mode-tag.p {
  background: #ffd2a8;
}

.card-mode-tag.m {
  background: #e2223b;
  text-align: center;
  color: #ededed;
}

button.add-cafe {
  width: 100%;
  background: transparent;
  height: 10vh;
  cursor: pointer;
  transition: 0.3s;
  border: 1px solid #ededed;
  color: #ededed;
  border-radius: 1.2vh;
  margin-top: 2.3vh;
  text-align: center;
  font-size: 2.3vh;
}

button.add-cafe:hover {
  background: #ededed;
  color: #1d1d1d;
}

.cafe-image,
.cafe-image-placeholder {
  object-fit: cover;
  border-radius: 1vh;
}

.general-info {
  width: 34.5vh;
  position: relative;
  margin-right: 1.7vh;
  color: #ededed;
}

.mode-switcher {
  background: #ededed;
  border-radius: 0.3vh;
  display: flex;
  height: 3vh;
  align-self: center;
  user-select: none;
}

.switch {
  text-align: center;
  border-radius: 0.3vh;
  width: 50%;
  font-size: 1.8vh;
  padding: 0.2vh 1vh;
  cursor: pointer;
  align-self: center;
  color: #464646;
}

.switch-active {
  color: #ededed;
  background: #464646;
}

.lite.switch-active {
  color: #aeccc6;
  background: #464646;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
  width: 100%;
}

.modal-button {
  background: transparent;
  font-size: 2vh;
  border: 1px solid #ededed;
  color: #ededed;
  text-align: center;
  padding: 0.5vh 1vh;
  border-radius: 0.8vh;
  cursor: pointer;
}

p.comment {
  margin: 0;
  padding-top: 2.3vh;
  font-size: 1.7vh;
}

.cancel {
  border: 1px solid #908f8d;
  color: #908f8d;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import BlackInput from "@/components/BlackInput.vue";
import CorporateCafeCard from "@/components/corporate/CafeCard.vue";
import AddCafeModal from "@/components/corporate/AddCafeModal.vue";

import CafeAPI from "@/api/cafe";

export default {
  data() {
    return {
      showPopup: false,
    };
  },
  methods: {
    fetchCafes() {
      this.$store.dispatch("fetchCorporateCafes");
    },
  },
  computed: {
    corporate_cafes() {
      return this.$store.state.corporate_cafes.filter((c) => {
        if (this.chain) {
          return c.chain_id == this.chain._id;
        } else {
          return true;
        }
      });
    },
    chain() {
      if (this.$route.params.id)
        return this.$store.getters.getChain(this.$route.params.id);

      if (this.$store.state.selected_chain)
        return this.$store.state.selected_chain;

      return null;
    },
  },
  mounted() {
    this.fetchCafes();

    if (this.chain) {
      const chain_id = this.chain._id;
      const cafe = this.$store.getters.chainCafes(this.chain._id);
      this.$store
        .dispatch("switchCafe", {
          cafe_id: cafe._id,
          from_chain: true,
        })
        .then(() => {
          this.$store.commit(
            "selectChain",
            this.$store.getters.getChain(chain_id)
          );
        });
    }
  },
  components: {
    IQOS,
    DashboardButton,
    BlackInput,
    CorporateCafeCard,
    AddCafeModal,
  },
};
</script>
